module.exports = __webpack_public_path__ + "img/badge-legal-waste.930b4de8.svg";